'use client';

import React, { createContext, useContext, useState, ReactNode, useEffect } from 'react';

interface HeaderContextType {
    isTransparentEnabled: boolean;
    setIsTransparentEnabled: (enabled: boolean) => void;
}

const HeaderContext = createContext<HeaderContextType | undefined>(undefined);

export const HeaderProvider = ({ children }: { children: ReactNode }) => {
    const [isTransparentEnabled, setIsTransparentEnabled] = useState(false);

    return (
        <HeaderContext.Provider value={{ isTransparentEnabled, setIsTransparentEnabled }}>
            {children}
        </HeaderContext.Provider>
    );
};

export const useHeader = () => {
    const context = useContext(HeaderContext);
    if (context === undefined) {
        throw new Error('useHeader must be used within a HeaderProvider');
    }
    return context;
};

/**
 * A helper component to set the header transparency from a server component (page).
 */
export const HeaderEffect = ({ isTransparent }: { isTransparent: boolean }) => {
    const { setIsTransparentEnabled } = useHeader();

    useEffect(() => {
        setIsTransparentEnabled(isTransparent);
        // Reset on unmount to default behavior
        return () => setIsTransparentEnabled(false);
    }, [isTransparent, setIsTransparentEnabled]);

    return null;
};
